import { Skeleton } from "@mui/material";
import { MuiBox } from "components/atoms";
import React from "react";

const HelpTabSkeleton = ({ count = 6 }) => {
  return (
    <MuiBox>
      <MuiBox
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          p: "20px",
        }}
      >
        {Array.from({ length: count }).map((_, index) => (
          <MuiBox
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            //   bgcolor: "background.blue200",
              borderRadius: "5px",
              p: "12px 16px",
              minHeight: "48px",
              gap: "12px",
            }}
          >
            {/* Title */}
            <Skeleton
              variant="text"
              width={`${55 + (index % 3) * 10}%`}
              height={24}
            />

            {/* Expand icon */}
            <Skeleton
              variant="rounded"
              width={24}
              height={24}
              sx={{ borderRadius: "4px", flexShrink: 0 }}
            />
          </MuiBox>
        ))}
      </MuiBox>

      {/* Footer */}
      <MuiBox
        sx={{
          display: "flex",
          gap: "12px",
          bgcolor: "background.gray200",
          p: "16px 20px",
          justifyContent: "flex-end",
        }}
      >
        <Skeleton
          variant="rounded"
          width={80}
          height={36}
          sx={{ borderRadius: "8px" }}
        />
      </MuiBox>
    </MuiBox>
  );
};

export default HelpTabSkeleton;